var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar'),_vm._v(" "),_c('main',{staticClass:"main"},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1),_vm._v(" "),_c('AppAside')],1),_vm._v(" "),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }